<template>
  <v-app>
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          lg="7"
          md="9"
        >
          <base-material-card
            color="green"
          >
            <template v-slot:heading>
              <div class="display-2 font-weight-light">
                Login
              </div>
            </template>

            <v-card-text>
              <v-container
                class="pa-0"
                fluid
              >
                <v-form>
                  <v-text-field
                    v-model="form.username"
                    label="Email"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    counter
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="doLogin"
                  ></v-text-field>
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click="doLogin"
                  >
                    Login
                  </v-btn>
                  <v-overlay :value="formOverlay">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                </v-form>
              </v-container>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    AUTH_LOGIN,
  } from '../../store/actions.types'

  export default {
    name: 'Login',

    components: {
    },

    data: () => ({
      showPassword: false,
      isLoggingInManual: false,
      expandOnHover: false,
      formOverlay: false,
      form: {
        username: '',
        password: '',
      },
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },

    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
    },
    watch: {
      isLoggedIn (n, o) {
        this.$router.push('/app')
      },
    },
    methods: {
      ...mapActions({
        login: AUTH_LOGIN,
      }),
      async doLogin () {
        this.formOverlay = true

        console.log('doing login!')
        await this.login({ email_address: this.form.username, password: this.form.password })
        this.formOverlay = false
      },
    },
    mounted () {
      if (this.isLoggedIn) {
        this.$router.push('/')
      }
    },
  }
</script>

<style scoped>

</style>
